import React from "react"
import { useVideoCarouselQuery } from '../../hooks/use-video-carousel-query'
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled/macro'
import { pulse } from 'react-animations';
import { useInView } from 'react-intersection-observer'
import { animate, View } from "../AnimationsHelper";
import { Theme2, Device } from "../Layout"
import { TestimonialsPolygon } from "../SVGs"

const animation = keyframes`${pulse}`;

const Container = styled.div`
  max-width: 75rem;
  padding: 0 2rem;
  margin: 0 auto;
`
const OuterContainer = styled.div`
display: grid;
position: relative;

.testimonialsContainer{
  height: auto;
}
.testimonialsPolygon{
  display: none;

  @media ${Device.lg}{
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: auto;
  }
}
`
const InnerContainer = styled.div`
grid-area: 1/1;
position: relative;
display: grid;
place-items: center;
color: ${Theme2.colors.light};
text-align: center;
margin: 3em 0;


img{
  max-width: 100%;
}

.largerText{
  font-family: ${Theme2.fonts.headings};
  font-weight: 700;
  font-size: 33px;
  line-height: 1.1;
  margin-bottom: 1rem;
  @media ${Device.md}{
    font-size: calc(33px + 47 * ((100vw - 768px) / 432));
  }
  @media ${Device.xl}{
    font-size: 80px;
  }
  &.animate {
					animation: 1s ${animation};
				}
}
.subtitle{
  font-family: ${Theme2.fonts.alternateHeadings};
  margin-bottom: 0.5rem;

  @media ${Device.md}{
    font-size: calc(19px + 13 * ((100vw - 768px) / 432));
  }
  @media ${Device.lg}{
    margin-bottom: 1rem;
  }
  @media ${Device.xl}{
    font-size: 32px;
  }
}
.quoteText{
 font-family: ${Theme2.fonts.headings};
 font-size: 40px; 
 line-height: 1.1;
 margin: 1.1em 0;

 @media ${Device.md}{
    font-size: calc(40px + 20 * ((100vw - 768px) / 432));
  }
  @media ${Device.xl}{
    font-size: 60px;
  }
}

.reasonsHolder{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;

  @media ${Device.lg}{
    grid-template-columns: repeat( 5, 1fr);
  }
}
.reasonsHolder > div{
  border-bottom: 1px solid ${Theme2.colors.neutral};
  padding: 15px;
  min-height: 264px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media ${Device.lg}{
    border-bottom: none;
    border-right: 1px solid ${Theme2.colors.neutral};
    min-height: 207px;
    padding: 0 15px;
  }
  p{
    margin: 1rem 0;
  }
}
.reasonsHolder > div:last-child, .reasonsHolder > div:nth-last-of-type(2):nth-child(odd){
  border-bottom: none;
}
.reasonsHolder > div:nth-child(odd) {
  border-right: 1px solid ${Theme2.colors.neutral};
  @media ${Device.lg}{
    :last-of-type{
      border-right: none;
    }
  }
}
.imgQuoteHolder{

  @media ${Device.lg}{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 5%;
    margin: 5% 0;
    place-items: center;
  }
}
.homeH1{
  font-size: 13px;
  margin-bottom: 1rem;
  color: ${Theme2.colors.light};
  @media ${Device.sm}{
font-size: calc(13px + 3 * ((100vw - 576px) / 624));
}
@media ${Device.xl}{
  font-size: 16px;
}
}
`

const VideoCarousel = ({hasH1}) =>{
  const { videoCarouselTitle, videoCarouselSubtitle, videoCarouselH1, videoCarouselVideos, videoCarouselQuote, videoCarouselReasons } = useVideoCarouselQuery()
  const [ref, inView] = useInView(View)
    return(
      <OuterContainer ref={ref}>
        
        <StaticImage
        style={{
          gridArea: "1/1",
        }}
        layout="fullWidth"
        
        // This is a presentational image, so the alt should be an empty string
        alt=""
        // Assisi, Perúgia, Itália by Bernardo Ferrari, via Unsplash
        src={
          "../../images/video-carousel-background.jpg"
        }
        formats={["auto", "webp", "avif"]}
      />
 
    <TestimonialsPolygon className="testimonialsPolygon" />

      <InnerContainer>
        <Container>
          <div>
          <p className={"largerText "+animate(inView)}>{videoCarouselTitle}</p>
        <p className="subtitle">{videoCarouselSubtitle}</p>
        {hasH1 !== false &&
        <h1 className="homeH1">{videoCarouselH1}</h1>
}
          </div>
        <div className="imgQuoteHolder">
        { videoCarouselVideos.map(videoCarouselVideo => {
    const { videoImage, videoImageAltText } = videoCarouselVideo;
    const image = getImage(videoImage.localFile)
    return (
      <GatsbyImage image={image} alt={videoImageAltText}/>
    )
  })}
<p className="quoteText">
  {videoCarouselQuote}
</p>
</div>

<div className="reasonsHolder">
{ videoCarouselReasons.map(videoCarouselReason => {
    const { videoCarouselReasonsImage, videoCarouselReasonsReason } = videoCarouselReason;
    return (
      <>
      <div>
        <img src={videoCarouselReasonsImage.localFile.publicURL} alt="" />
        <p>{videoCarouselReasonsReason}</p>
      </div>

    </>
    )
  })}
  </div>

  </Container>
  </InnerContainer>
  
        </OuterContainer>
    )
}

export default VideoCarousel